import { apiConstants } from "../../../utils/apiConstants";
import { apiTypes } from "../../../utils/apiTypes";
import apiRequestType from "../../apiRequestType";

const unlockUserAccount = (data) => {
  return apiRequestType(
    apiTypes.POST,
    apiConstants.ADMIN.USER_MANAGEMENT.UNLOCK_USER_ACCOUNT,
    data
  );
};

export default unlockUserAccount;
